<mat-card class="curve-card">
  <mat-card-header>
    <mat-card-title>{{ title() }}</mat-card-title>
    @if (curve(); as current) {
      <mat-card-subtitle>{{ current.coverageStartDate.format('YYYY-MM-DD') }} – {{ current.coverageEndDate.format('YYYY-MM-DD') }} · {{ current.totalDataPoints | number }} observations</mat-card-subtitle>
    }
  </mat-card-header>
  <mat-card-content>
    @if (curve(); as current) {
      <mat-button-toggle-group aria-label="Curve normalization" [value]="normalized()" (change)="normalized.set($event.value)">
        <mat-button-toggle [value]="true">Normalized</mat-button-toggle>
        <mat-button-toggle [value]="false">Customer count</mat-button-toggle>
      </mat-button-toggle-group>
      <div #chart class="curve-chart" role="img" aria-label="Average power outage curve"></div>
      <div class="uncertainty-legend" aria-label="Curve uncertainty legend">
        <span><i class="tau-band"></i>Tau ±1 standard deviation</span>
        <span><i class="impact-duration"></i>Impact duration CI</span>
        <span><i class="recovery-duration"></i>Recovery duration CI</span>
        <span><i class="impact-level"></i>Impact level CI</span>
      </div>
      <div class="metric-grid">
        <div><span>Average peak</span><strong>{{ current.avgImpactLevelNormalized | percent:'1.1-2' }}</strong><small>of reference customers</small></div>
        <div><span>Escalation</span><strong>{{ current.avgImpactDuration === null ? '—' : ((current.avgImpactDuration / 60 | number:'1.1-1') + ' h') }}</strong><small>average duration</small></div>
        <div><span>Recovery</span><strong>{{ current.avgRecoveryDuration === null ? '—' : ((current.avgRecoveryDuration / 60 | number:'1.1-1') + ' h') }}</strong><small>average duration</small></div>
        <div><span>Normalization</span><strong>{{ current.countySize | number:'1.0-0' }}</strong><small>reference customers</small></div>
      </div>
      <p class="source">Dataset: {{ current.datasetKey }} · Threshold: {{ current.threshold | number:'1.0-0' }} customers</p>
    } @else {
      <div class="no-data"><strong>No average curve is available.</strong><span>Choose another period or county.</span></div>
    }
  </mat-card-content>
</mat-card>
